/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRecherchePlanAgrementClasseDto } from './FcbRecherchePlanAgrementClasseDto';
import {
    FcbRecherchePlanAgrementClasseDtoFromJSON,
    FcbRecherchePlanAgrementClasseDtoFromJSONTyped,
    FcbRecherchePlanAgrementClasseDtoToJSON,
} from './FcbRecherchePlanAgrementClasseDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRecherchePlanAgrementClasseDtoPaginatedResults
 */
export interface FcbRecherchePlanAgrementClasseDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRecherchePlanAgrementClasseDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRecherchePlanAgrementClasseDto>}
     * @memberof FcbRecherchePlanAgrementClasseDtoPaginatedResults
     */
    results?: Array<FcbRecherchePlanAgrementClasseDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRecherchePlanAgrementClasseDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRecherchePlanAgrementClasseDtoPaginatedResults interface.
 */
export function instanceOfFcbRecherchePlanAgrementClasseDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRecherchePlanAgrementClasseDtoPaginatedResultsFromJSON(json: any): FcbRecherchePlanAgrementClasseDtoPaginatedResults {
    return FcbRecherchePlanAgrementClasseDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRecherchePlanAgrementClasseDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRecherchePlanAgrementClasseDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRecherchePlanAgrementClasseDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRecherchePlanAgrementClasseDtoPaginatedResultsToJSON(value?: FcbRecherchePlanAgrementClasseDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRecherchePlanAgrementClasseDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

